import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  isFirstOpen = true;
  oneAtATime: boolean = true;

}
